import React from "react";

export const CareFinderRoutes = React.lazy(() =>
  import("@leagueplatform/care-finder").then((module) => ({
    default: module.CareFinderRoutes,
  }))
);

export const AppointmentSchedulingRoutes = React.lazy(() =>
  import("@leagueplatform/care-finder").then((module) => ({
    default: module.AppointmentSchedulingRoutes,
  }))
);

export const LazySchedulingFlowOverlay = React.lazy(() =>
  import("@leagueplatform/care-finder").then((module) => ({
    default: module.SchedulingFlowOverlay,
  }))
);

// QUEST-2796 — the bridge imports `useStartSchedulingFlow` from
// `@leagueplatform/care-finder`; lazy-loading keeps that import out of the
// main bundle and mirrors the code-splitting boundary used by the overlay.
export const LazyQuestSchedulingFlowBridge = React.lazy(() =>
  import(
    "components/quest-scheduling-flow-bridge/quest-scheduling-flow-bridge.component"
  ).then((module) => ({ default: module.QuestSchedulingFlowBridge }))
);

export const HealthJourneyRoutes = React.lazy(() =>
  import("@leagueplatform/health-journey").then((module) => ({
    default: module.HealthJourneyRoutes,
  }))
);

export const HealthProfileRoutes = React.lazy(() =>
  import("@leagueplatform/health-profile").then((module) => ({
    default: module.HealthProfileRoutes,
  }))
);

export const AboutMeRoutes = React.lazy(() =>
  import("@leagueplatform/about-me").then((module) => ({
    default: module.AboutMeRoutes,
  }))
);
export const CareCollectionsRoutes = React.lazy(() =>
  import("@leagueplatform/care-collections").then((module) => ({
    default: module.CareCollectionsRoutes,
  }))
);
export const CareDocumentsRoutes = React.lazy(() =>
  import("@leagueplatform/care-documents").then((module) => ({
    default: module.CareDocumentsRoutes,
  }))
);
export const AchievementsRoutes = React.lazy(() =>
  import("@leagueplatform/rewards-achievements").then((module) => ({
    default: module.AchievementsRoutes,
  }))
);
export const DashboardRoutes = React.lazy(() =>
  import("@leagueplatform/dashboard").then((module) => ({
    default: module.DashboardRoutes,
  }))
);
export const LabResultsRoutes = React.lazy(() =>
  import("@leagueplatform/dashboard").then((module) => ({
    default: module.LabResultsRoutes,
  }))
);
